/* eslint-disable react/display-name */
import React from 'react';
import { BLOCKS, Document, Node } from '@contentful/rich-text-types';
import Image from '../../components/primitives/image/Image';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

interface Props {
    content: {
        json: Document;
    };
}

const CONTENT_PAGE_IMAGE_WIDTH = 800;
const renderOptions = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node: Node) => {
            const { title, file, description = '' } = node.data.target.fields;
            const resizedImageUrl = `${file.url}?w=${CONTENT_PAGE_IMAGE_WIDTH}`;
            return (
                <Image
                    title={title}
                    src={resizedImageUrl}
                    description={description}
                />
            );
        },
    },
};

const ContentFulRichText = ({ content }: Props) => (
    <div className="wysiwyg">
        {documentToReactComponents(content.json, renderOptions)}
    </div>
);

export default ContentFulRichText;
